/* eslint-disable */
const NON_PRINTABLE_CHARACTERS = /[\x00-\x1F\x7F-\x9F]/g;
/* eslint-enable */

/**
 * The only invalid line-break we know of so far is \r which was used by MacOS <= 9
 * It causes problems with modern browsers and has to be replaced
 */

const RE_INVALID_LINEBREAKS = /\r(?!\n)/gm;
const VALUE_VALID_LINEBREAK = '\n';

export const containsInvalidLinebreaks = (str: string): boolean =>
    Boolean(str.match(RE_INVALID_LINEBREAKS));

export const removeNonPrintables = (text) => text.replace(NON_PRINTABLE_CHARACTERS, '');

export const containsNonPrintables = (text) => NON_PRINTABLE_CHARACTERS.test(text);

export const sanitizeInvalidLinebreaks = (str: string): string =>
    str.replace(RE_INVALID_LINEBREAKS, VALUE_VALID_LINEBREAK);

export const sanitizeHtml = (string: string | null) => {
    const parser = new DOMParser();

    if (string) {
        const doc = parser.parseFromString(string, 'text/html');

        const plainText = doc.body?.textContent || '';

        return plainText;
    }

    return '';
};

export const matchSomeValue = (string, values) =>
    values.some(
        (i) =>
            (i instanceof RegExp && string.match(i)) ||
            string.toLowerCase() === String(i).toLowerCase(),
    );

// eslint-disable-next-line eqeqeq
export const isNumberish = (value) => parseFloat(value) == value;

export const isLetter = (c) => Boolean(c?.match?.(/[a-zA-Z]/));

export const LIPSUM = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sit amet hendrerit libero. Praesent placerat mattis purus vel placerat. Nam sagittis, metus sed gravida gravida, augue arcu convallis lorem, eu scelerisque augue enim vel diam. Etiam venenatis ornare felis consectetur congue. Nulla blandit ex eu tortor vestibulum, at aliquet est hendrerit. Quisque varius tellus urna, non dapibus elit accumsan at. Nam gravida ex non leo vestibulum volutpat. Praesent sapien diam, tincidunt ut diam sit amet, accumsan vulputate erat. Nulla consectetur, sapien eget iaculis commodo, arcu quam tempus augue, et fermentum neque libero convallis elit. Aliquam vitae dapibus dolor. Nam leo odio, varius vel suscipit vitae, posuere sed ex. Integer eu dignissim magna. Vestibulum vulputate tristique tortor, vel pulvinar nisi cursus in. Phasellus ac velit imperdiet, finibus massa in, vulputate lorem. Nullam at nibh et ligula rhoncus rhoncus. Mauris porta laoreet pulvinar. Morbi vel risus sit amet tellus hendrerit convallis quis at mauris. Aenean ac turpis ac arcu molestie eleifend. Curabitur convallis elementum odio nec laoreet. Ut eu elementum ante. In lacinia eros eget magna venenatis, at eleifend odio ultrices. Suspendisse rhoncus eu turpis ut gravida. Aenean non elit congue, venenatis massa sed, scelerisque nisi. Donec tempor dictum egestas. Sed tellus ligula, vulputate nec tincidunt id, aliquet ut nunc. Nunc eget pretium justo, ut consequat dolor. Nullam luctus eleifend erat et faucibus. Curabitur quis finibus diam. Cras erat elit, tempor nec augue sed, sodales vehicula magna. Donec tincidunt massa id quam pellentesque vestibulum. Pellentesque porta rhoncus est, et finibus tellus hendrerit nec. Nunc vehicula viverra lacinia. Duis arcu leo, gravida eget lacinia eu, laoreet at tellus. Donec sed leo tincidunt, pulvinar orci nec, semper erat. Quisque sodales in eros sit amet vulputate. Duis consequat eleifend ornare. Etiam ut facilisis nulla, cursus consectetur orci. Ut at congue ligula. Donec sed sapien eleifend, aliquet quam ut, mattis sem. Phasellus rutrum rutrum sollicitudin. Mauris pulvinar gravida finibus. Curabitur eget sagittis arcu, sed suscipit est. Nunc tristique mauris est, eget blandit lacus rhoncus at. Vestibulum sodales odio ac mi placerat venenatis. Sed luctus nunc orci, ac dictum tortor vehicula id. Aliquam scelerisque scelerisque dolor, sed egestas velit congue vel. Curabitur pharetra accumsan quam, a ultricies quam consequat eget. Cras porttitor interdum diam non commodo. Fusce tincidunt tempor quam eget aliquam. Praesent elementum blandit suscipit. Vestibulum porta fermentum luctus. Morbi posuere rutrum accumsan. Fusce interdum dapibus lectus, sed imperdiet orci aliquam id. Praesent mattis commodo elit eu tincidunt. Nunc sit amet tellus nisi. Nam rutrum massa in quam accumsan, eget aliquet erat porttitor. Mauris ac lobortis mauris. Curabitur elit purus, luctus a mi vel, venenatis volutpat risus. Nunc dictum pulvinar ipsum, vitae maximus velit. Nullam tempus vitae ex at rhoncus. Ut dignissim facilisis nunc a cursus. Ut congue fringilla ex, at pellentesque odio interdum ut. In aliquam diam mi, at tincidunt mi pharetra sit amet. Sed suscipit vitae elit id scelerisque.`;

export const lipsum = (wordsCount = 0, start = 0) => {
    if (wordsCount === 0) {
        return LIPSUM;
    }

    const parse = () => {
        const out: number[] = [];

        for (let i = 0, inWord = false; i < LIPSUM.length; i++) {
            const c = LIPSUM[i];

            if (inWord === false && isLetter(c)) {
                out.push(i);
            }
            inWord = isLetter(c);
        }

        return out;
    };

    const parsed = parse();

    return LIPSUM.substring(parsed[start], parsed[start + wordsCount] - 1);
};

export const replaceDiacriticalMarks = (value) =>
    typeof value === 'string' ? value.normalize('NFD').replace(/[\u0300-\u036f]/gi, '') : value;
